export const hasSpecifiedPermission = (requiredPermission, userPermissions) => userPermissions.includes(requiredPermission)

export const permission = {
    READ: 0,
    CREATE: 1,
    UPDATE: 2,
    DELETE: 3,
    REVIEW: 4,
    APPROVE: 5,
}
